import { render } from "./UserStatistics.vue?vue&type=template&id=bec6df4a&scoped=true"
import script from "./UserStatistics.vue?vue&type=script&lang=js"
export * from "./UserStatistics.vue?vue&type=script&lang=js"

import "./UserStatistics.vue?vue&type=style&index=0&id=bec6df4a&scoped=true&lang=scss"

import exportComponent from "/Users/emmanueledurante/Documents/Lavoro/Martech/Whappy1/whappy-app-front-vue/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bec6df4a"]])

export default __exports__